import * as React from 'react';

import PropTypes from 'prop-types';

import _t from 'i18n!nls/discussions';

import 'css!./__styles__/AdminDetails';

class AdminDetails extends React.Component {
  static propTypes = {
    post: PropTypes.object.isRequired,
  };

  render() {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'post' does not exist on type 'Readonly<{... Remove this comment to see the full error message
    const { post } = this.props;
    return post.showAdminDetails ? (
      <div className="rc-AdminDetails align-self-end">
        <p>{_t('User ID') + ': ' + post.creator?.userId || _t('Not Available')}</p>
      </div>
    ) : null;
  }
}

export default AdminDetails;
